import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '~/store';

export const dialogsSelector = (state: RootState) => state.dialogs.dialogs;

export const isDialogOpenSelector = createSelector([dialogsSelector], (dialogs) => {
  return dialogs.length > 0;
});
